module.exports = __webpack_public_path__ + "static/img/bgc.6db2962d.png";